<template>
  <div>
    <section class="hero is-danger">
      <h3 class="is-size-3">
        過去ログ一覧
      </h3>
    </section>
    <section class="section">
      <div class="container">
        <div v-if="isErrors">
          <p class="hero">
            <span class="has-text-danger">{{ isErrors }}</span>
          </p>
        </div>
        <!-- 検索 -->
        <div class="box">
          <div class="columns">
            <div class="column">
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="lable">グループ</label>
                </div>
                <div class="field-body">
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="select">
                        <select v-model="inputForm.group">
                          <option value="0">選択してください</option>
                          <option v-for="group in groups" v-bind:value="group.id" v-bind:key="group.id">{{ group.name }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="lable">カテゴリ</label>
                </div>
                <div class="field-body">
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="select">
                        <select v-model="inputForm.category">
                          <option value="0">選択してください</option>
                          <option v-for="category in categorys" v-bind:value="category.id" v-bind:key="category.id">{{ category.name }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-2">
              <button class="button is-danger" @click="clear">クリア</button>
            </div>
          </div>
        </div>
        <!-- 検索 ここまで -->
        <!-- リスト表示 -->
        <div>
          <div class="newslist is-size-5" v-for="item in getItems" v-bind:key="item.id">
            <router-link :to="{ name: 'LogsDetails', params: { news: item.id } }">
              {{ item.title }} 
              <template v-if="item.isNotPostingTerm !== '1'">
                ({{ item.from_date }} ～ {{ item.to_date }})
              </template>
              </router-link>
          </div>
          <nav class="pagination is-centered" role="navigation" aria-label="pagination">
            <paginate
              v-model="page.currentPage"
              :page-count="getPageCount"
              :page-range="3"
              :margin-pages="2"
              :click-handler="clickCallback"
              :prev-text="'前'"
              :next-text="'次'"
              :container-class="'pagination-list'"
              :page-link-class="'pagination-link'"
              :page-class="''"
              :hide-prev-next="true"
              :prev-link-class="'pagination-previous'"
              :next-link-class="'pagination-next'"
              :active-class="'pagination-link is-current'"
              :no-li-surround="true">
            </paginate>
          </nav>
        </div>
        <!-- リスト表示 ここまで-->
      </div>
    </section>
    <section class="section">
      <div class="hero">
        <div class="field">
          <router-link to="/">
            <button class="button is-rounded is-link is-size-5">戻る</button>
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState} from 'vuex'
import Paginate from 'vuejs-paginate'

export default {
  data() {
    return {
      inputForm: {
        group: '0',
        category: '0',
      },
      page: {
        parPage: 7,
        currentPage: 1
      }
    }
  },
  watch:{
    'inputForm.group': function(val){
      this.$set( this.inputForm, 'category', '0')
      this.setLosgCurrentPage({ input: this.inputForm, page: 1})
      this.categorySet(val)
      //ここにnews検索ロジックを組み込む
      // this.searchNews()
    },
    'inputForm.category': function(){
      //ここにnews検索ロジックを組み込む
      this.setLosgCurrentPage({ input: this.inputForm, page: 1})
      // this.searchNews()
    },
  },
  created () {
    this.clearError()
  },
  computed: {
    ...mapGetters({
      groups: 'news/groups',
      categorys: 'news/categorys',
      newsLists: 'news/news',
      currentPage: 'status/logsListStatus',
    }),
    ...mapState({
      apiStatus: state => state.news.apiStatus,
      isErrors: state => state.news.errorMessages,
      getItems(state) {   //mapStateの中でthisを使う際にはアローはNG
        this.page.currentPage = state.status.logsListStatus.page
        this.inputForm = state.status.logsListStatus.input
        let current = this.page.currentPage * this.page.parPage
        let start = current - this.page.parPage
        let list = this.newsLists(this.inputForm)
        return list.slice(start, current)
      },
      getPageCount: function() {
        let list = this.newsLists(this.inputForm)
        return Math.ceil(list.length / this.page.parPage)
      }
    })
  },
  components:{
    'paginate': Paginate,  //https://www.kabanoki.net/4320/
  },
  mounted(){
    this.$store.dispatch('news/newsGroupAndCategory')
    this.$store.dispatch('news/getAllNews')
  },
  methods: {
    ...mapActions({
      setCategory: 'news/filCategorys',
      setLosgCurrentPage: 'status/setLosgCurrentPage',
    }),
    //グループが変更されたとき呼ばれる
    categorySet(key){
      this.setCategory(key)
    },
    clearError () {
      this.$store.commit('news/setErrorMessages', null)
    },
    clickCallback: function (pageNum) {
      this.setLosgCurrentPage({ input: this.inputForm, page: Number(pageNum) })
    },
    clear(){
      this.$set( this.inputForm, 'group', '0')
    }
  }
}
</script>

<style scoped>
  .hero {
    text-align: center
  }
  .newslist{
    padding-bottom: 12px;
  }
</style>